import { PopoverService } from './services/popover.service';

import { Component, ContentChild, EventEmitter, Input, Output, ViewChild, NgZone } from '@angular/core';
import { NgbCollapseModule, NgbDropdown, NgbModal, NgbModule, Placement } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../core/components/base.component';
import { v4 } from 'uuid';

@Component({
    selector: 'epmax-popover',
    imports: [NgbCollapseModule, NgbModule],
    providers: [NgbModal],
    templateUrl: './popover.component.html',
    styleUrl: '../dropdown/dropdown.component.scss'
})
export class PopoverComponent extends BaseComponent {
    @Input() id!: string | number;
    @Input('childrenPopovers') children: (string | number)[] = [];
    @ViewChild(NgbDropdown) dropdown!: NgbDropdown;
    @Input('autoClose') autoClose: boolean | 'outside' = true;
    @ViewChild('content') content!: NgbDropdown;
    @ContentChild('body') bodyContent!: any;
    @Input('container') container: any = 'body';
    @Input('customClass') customClass: string = '';
    @Output('onStatusChange') onStatusChange: EventEmitter<any> = new EventEmitter();
    placement: Placement[] = ['bottom-end', 'bottom-start', 'top-end', 'top-start', 'auto'];
    @Input() reversePlacement: boolean = false;
    @Input() ishovering: boolean = false;
    popoverLeaveTimeout: any;
    popoverEnterTimeout: any;
    isOpen: boolean = false;
    private handleOutsideClick!: (event: PointerEvent) => void;
    constructor(
        private translateService: TranslateService,
        private popoverService: PopoverService,
        private ngZone: NgZone // Injecting NgZone
    ) {
        super();
        this.subscription = this.popoverService.popoversList.subscribe((res: any) => {
            if ((!res.id || res.id != this.id) && !this.children.includes(res?.id as never)) {
                this.ngZone.run(() => { // Running inside Angular's zone
                    this.dropdown.close();
                });
            }
        });

    }

    public get language() {
        return this.translateService.currentLang;
    }

    onClickHeader() {
        this.popoverService.popoversList.next(this);
    }
    mouseEnterPopup(): void {
        if (this.ishovering == false) return;

        clearTimeout(this.popoverLeaveTimeout);
        this.popoverEnterTimeout = setTimeout(() => {
            this.open()
            window.removeEventListener('scroll', this.close, true);
        }, 500);
    }

    mouseLeavePopup(): void {
        if (this.ishovering == false) return;
        if (!this.isOpen)
            clearTimeout(this.popoverEnterTimeout);

        this.popoverLeaveTimeout = setTimeout(() => {
            clearTimeout(this.popoverEnterTimeout);
            this.close();
        }, 500);

    }
    open(): void {
        this.ngZone.run(() => { // Running inside Angular's zone
            this.dropdown.open();
            this.isOpen = true;
        });
    }

    toggle(): void {
        this.ngZone.runOutsideAngular(() => { // Running outside Angular's zone
            this.dropdown.toggle();
            this.isOpen = !this.isOpen;
        });
    }

    close(): void {
        this.ngZone.run(() => { // Running inside Angular's zone
            this.dropdown.close();
            this.isOpen = false;
        });
    }

    stopPropagation(event: any) {
        event.stopPropagation();
    }

    onDropdownOpenCloseChange(event: any) {
        this.onStatusChange.emit(event);
    }

    protected override ngSuperOnInit() {
        if (this.id === undefined) {
            this.id = v4();
        }

        if ((this.language == 'ar' && this.reversePlacement) || (this.language == 'en' && !this.reversePlacement)) {
            this.placement = ['bottom-start', 'bottom-end', 'top-start', 'top-end', 'auto'];
        }
    }

    
    closeWhenClickOutsidePopover(){
        const menuContainer = document.querySelector('.dropdown-menu.menuContainer');
        this.handleOutsideClick = (event: PointerEvent) => {
            const target = event.target as HTMLElement;
            if (target.closest('[toggle]')  || target.closest('.ng-dropdown-panel-items') || target.closest('.epmaxCalendarContainer')) {
                return;
              }
            if (!menuContainer?.contains(target as Node)) {
              this.close();
            }
        };

        document.addEventListener('click', this.handleOutsideClick)
    }

    protected override ngSuperAfterViewInit() {
        if (this.autoClose == 'outside') {
            this.closeWhenClickOutsidePopover()
        }
    }

    protected override ngSuperOnDestroy() {
        if (this.autoClose == 'outside') {
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }



}
